'use strict';

var React = require('react'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    FontLoader = require('../utils/FontLoader'),
    onlyChild = require('react/lib/onlyChild'),
    { PropTypes } = React;

var FontTest = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    family: PropTypes.oneOf(['minion-pro-condensed', 'playfair-display']),
    test: PropTypes.string
  },

  componentDidMount() {
    this.loadFontIfNeccessary();
  },

  componentDidUpdate(prevProps) {
    if (prevProps.test !== this.props.test) {
      this.loadFontIfNeccessary();
    }
  },

  loadFontIfNeccessary() {
    var { test, family } = this.props;
    if (test && family) {
      FontLoader.ensureCanRenderString(test, family);
    }
  },

  render() {
    return onlyChild(this.props.children);
  }
});

module.exports = FontTest;


/** WEBPACK FOOTER **
 ** ./atoms/FontTest.jsx
 **/